import api from "./api";

class AnagraficaGamma {

    clientiGamma(config?: any) {
        return api.get(`/anagrafica_gamma/clienti/`,config )
    }

    clienteGamma(id: number | string | undefined, config?: any) {
        return api.get(`/anagrafica_gamma/clienti/${id}/`, config )
    }

    list = this.clientiGamma
    retrieve = this.clienteGamma
    paginatedList = this.clientiGamma
}

const anagraficaGamma = new AnagraficaGamma()

export default anagraficaGamma
